import Indicador from "..";
import TorrEditFields from "./components/TorrEditFields";
import { TorrParamFields } from "./components/TorrParamFields";
import torrReport from "./reports";
import torrReportSummary from "./reports/summary";

export default class Torr extends Indicador {
    static get fullName() {
        return "Torrões";
    }

    static get abbrev() {
        return "Torr.";
    }

    static get field() {
        return "torr";
    }

    static paramFields(tipoIndicadorField = '') {
        return <TorrParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <TorrEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return torrReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return torrReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        const total = apontamento.coletas.length;
        const countSim = apontamento.coletas.filter(c => c.torroes === "Sim").length;
        return ((countSim / total) * 100).toFixed(2);
    }

    static getConformidadeStatus(conformidade, meta) {
        return this.calcConformidadeStatusInverte(conformidade, meta, 117.05, 100, 83.61);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        return [];
    }

    static getResultStr(apontamento) {
        if (!apontamento.coletas) return "";
        const total = apontamento.coletas.length;
        const countSim = apontamento.coletas.filter(c => c.torroes === "Sim").length;
        return `Torrões presentes: ${countSim} de ${total}`;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },
            { title: "Talhão", field: "talhao.nome" },
            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },
            {
                title: "Torrões (%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }
}
